export default {
    Alerts: 'התראות',
    Goal: 'יעד שנתי',
    Current: 'מצב נוכחי',
    Location: 'מיקום',
    Opens: 'שעת פתיחה',
    Closes: 'שעת סגירה',
    OnDate: 'תאריך',
    Share: 'שתף',
    mapGO: 'סע',
    AddToCalendar: 'הוספה ליומן',
    SettingsPersonal: 'פרטים אישיים',
    SettingsReminders: 'תזכורות',
    SettingsHowToDonate: 'איך להתנדב',
    SettingsHelpAndSupport: 'עזרה ותמיכה',
    SettingsContactUs: 'צור קשר',
    SettingsFAQ: 'שאלות נפוצות',
    SettingsAbout: 'אודות',
    ReminderSettingsPhoneNotification: 'האם תרצה לקבל התראות לטלפון שלך?',
    Yes: 'כן',
    No: 'לא',
    Home: 'דף בית',
    Personal: 'היסטוריה',
    Goals: 'יעדים',
    Settings: 'הגדרות',
    Map: 'מפה',
    Date: "תאריך",
    Pulse: "דופק",
    Pressure: "לחץ דם",
    Hemoglobin: "המוגלובין",
    MapScreenTitle: "תחנות התרמה",
    PersonalScreenTitle: "היסטורית התרמות",
    WhatIYourNames: "הכנס את השם שלך",
    WhatIYourBloodType: "סוג הגדם",
    ChooseYourBloodType: "תבחר את סוג הדם שלך",
    PersonalSettings: "הגדרות אישיות",
    HowManyTimesDidYouDonateBlood: "כמה פעמים כבר תרמת דם?",
    HowManyTimesWouldYouLikeToDonatePerYear: "כמה פעמים אתה מתכנן לתרום דם השנה?",
    RemindersSettings: 'התראות',
    SearchPlaceholder: 'חיפוש...',
    Donations: 'תרומות',
    Language: 'שפה',
    MostRecentDonation: 'מתי הייתה תרומת הדם האחרונה שלך?',
    shareMessageTitle: `הי, רציתי לשתף אותך שניתן לתרום דם ב (1) ב (2) - תודה!`,
    AddToCalendarTitle: 'תרומת דם - תודה!',
    AddToCalendarDescription: ' ',
    shareMessageBody: ' ',
    yourPersonalGoals:"היעד האישי שלך"
}

